module.exports = __webpack_public_path__ + "static/whatif-8d9455fadf8b165b2ae1b5e7b9f9f40a.svg";